module.exports = __webpack_public_path__ + "static/media/rodrigo-falco.89ddc3cc.png";